// src/modules/app-views/_apps/appsindico/units/pages/Init/actions/actionButton.js
import { PlusOutlined } from '@ant-design/icons';

const unitsInitActionButton = () => {
  return {
    action: 'new',
    hideButton: false,
    label: 'new',
    tooltip: 'new_unit',
    icon: <PlusOutlined />,
    type: 'primary',
    disabled: false,
    onClick: ({ navigate, setPage }) => {
      setPage({
        navigate,
        pageName: 'document',
        params: { _id: 'add' },
      });
    },
    dropdownItems: [],
  };
};

export default unitsInitActionButton;
